export default function () {
	return {
		open: false,
		openButton: document.querySelector('[data-cart-open]'),
		cartForm: null,
		promoData: null,
		cartData: null,

		get discountMessages() {
			const messageContainer = document.querySelector('[data-discount-messages]');
			if (!messageContainer) return null;
			const messages = JSON.parse(messageContainer.innerHTML);
			return messages;
		},

		get autoGiftsData() {
			let giftsData = null;
			const cartDrawer = document.querySelector('.cart-drawer');
			if (cartDrawer && cartDrawer.hasAttribute('data-gifts')) {
				giftsData = JSON.parse(window.atob(cartDrawer.dataset.gifts));
			}

			return giftsData;
		},

		openCart() {
			if (!this.openButton) return;
			this.openButton.addEventListener('click', () => {
				this.open = true;
				document.body.style.overflow = 'hidden';
			});
		},

		closeCart() {
			this.open = false;
			document.body.style.overflow = 'auto';
		},

		updateCart(event) {
			if (!event?.detail?.cartData) return;
			const sections = event?.detail?.cartData?.sections['cart-drawer-sections'];
			if (!sections) return;
			const parser = new DOMParser().parseFromString(sections, 'text/html');
			this.getSectionsToRerender().forEach((section) => {
				const parent = document.querySelector(section);
				const HTML = parser.querySelector(section);
				if (parent && HTML) {
					if (
						parent.hasAttribute('data-cart-drawer-progress') &&
						HTML.hasAttribute('data-cart-drawer-progress')
					) {
						this.handleProgressChange(parent, HTML);
					} else {
						parent.innerHTML = HTML.innerHTML;
					}
				}
			});
			this.open = true;
			this.getPromoData();
			this.addAutomatedGifts();

			setTimeout(() => {
				this.calculateItemsMaxHeight();
			}, 500);
		},

		onQuantityInputChange(itemKey) {
			let quantity = this.$el.value;
			let formData = {
				updates: {},
				sections: 'cart-main,cart-drawer-sections',
			};

			formData.updates[itemKey] = quantity;

			const hasPromo = this.$el.closest('[data-promo]');
			if (hasPromo && this.promoData && Number(quantity) === 0) {
				const idFromLine = itemKey.split(':')[0];
				if (idFromLine !== this.promoData.variantID) {
					formData.updates[this.promoData.variantID] = 0;
				}
				let discountMap = '';
				const discounts = this.cart.discount_codes.filter(
					(item) => item.code !== this.promoData.discountCode && item.applicable === true,
				);
				if (discounts.length !== 0) {
					discountMap = discounts.map((item) => item.code).join(',');
				}

				formData.discount = discountMap;
			}
			this.onCartUpdate(formData);
		},

		itemIncrease(itemKey, itemQty) {
			let quantity = +itemQty + 1;
			let formData = {
				updates: {},
				sections: 'cart-main,cart-drawer-sections',
			};

			formData.updates[itemKey] = quantity;
			this.onCartUpdate(formData);
		},

		itemReduce(itemKey, itemQty) {
			let quantity = +itemQty - 1;
			let formData = {
				updates: {},
				sections: 'cart-main,cart-drawer-sections',
			};

			formData.updates[itemKey] = quantity;
			const hasPromo = this.$el.closest('[data-promo]');
			if (hasPromo && this.promoData && Number(quantity) === 0) {
				const idFromLine = itemKey.split(':')[0];
				if (idFromLine !== this.promoData.variantID) {
					formData.updates[this.promoData.variantID] = 0;
				}
				let discountMap = '';
				const discounts = this.cart.discount_codes.filter(
					(item) => item.code !== this.promoData.discountCode && item.applicable === true,
				);
				if (discounts.length !== 0) {
					discountMap = discounts.map((item) => item.code).join(',');
				}

				formData.discount = discountMap;
			}

			this.onCartUpdate(formData);
		},

		itemDelete(itemKey) {
			let quantity = 0;
			let formData = {
				updates: {},
				sections: 'cart-main,cart-drawer-sections',
			};

			formData.updates[itemKey] = quantity;
			const hasPromo = this.$el.closest('[data-promo]');
			if (hasPromo && this.promoData && Number(quantity) === 0) {
				const idFromLine = itemKey.split(':')[0];
				if (idFromLine !== this.promoData.variantID) {
					formData.updates[this.promoData.variantID] = 0;
				}
				let discountMap = '';
				const discounts = this.cart.discount_codes.filter(
					(item) => item.code !== this.promoData.discountCode && item.applicable === true,
				);
				if (discounts.length !== 0) {
					discountMap = discounts.map((item) => item.code).join(',');
				}

				formData.discount = discountMap;
			}
			this.onCartUpdate(formData);
		},

		async onCartUpdate(data, removePromo) {
			const url = `${window.Shopify.routes.root}cart/update.js`;
			const config = {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify(data),
			};

			try {
				const response = await fetch(url, config);
				const data = await response.json();
				if (!response.ok) return;
				this.$dispatch('cart-update', { cartData: data });
				if (this.promoData && removePromo) {
					this.removeDiscount(this.promoData.discountCode);
				}
			} catch (error) {
				console.error(error);
			}
		},

		getSectionsToRerender() {
			return [
				'[data-cart-items]',
				'[data-cart-drawer-progress]',
				'[data-cart-shipping-text]',
				'[data-cart-drawer-total]',
				'[data-cart-quantity]',
			];
		},

		async applyDiscount() {
			let discounts = '';
			const discount = this.$refs.discountInput.value;
			if (!discount) return;
			if (this.cart.discount_codes.length > 0) {
				const appliedDiscounts = this.cart.discount_codes.filter(
					(item) => item.code !== discount && item.applicable === true,
				);
				if (appliedDiscounts.length > 0) {
					discounts = appliedDiscounts
						.map((item) => item.code)
						.join(',')
						.concat(`,${discount}`);
				}
			} else {
				discounts = discount;
			}

			this.$el.classList.add('loading');

			const url = `${window.Shopify.routes.root}cart/update.js`;
			const discountData = {
				discount: discounts,
				sections: 'cart-main,cart-drawer-sections',
				sections_url: window.location.pathname,
			};
			const config = {
				method: 'POST',
				credentials: 'same-origin',
				headers: {
					'Access-Control-Allow-Origin': 'no-cors',
					'Content-Type': 'application/json',
				},
				body: JSON.stringify(discountData),
			};

			const response = await fetch(url, config);
			const data = await response.json();

			if (!response.ok) return;
			const appliedDiscount = data.discount_codes.find(
				(item) => item.code === discount && item.applicable,
			);

			appliedDiscount
				? this.handleDiscountMessage('success', discount)
				: this.handleDiscountMessage('error', discount);
			this.$refs.discountInput.value = '';
			this.$el.classList.remove('loading');
			this.$dispatch('cart-update', { cartData: data });

			if (
				this.promoData &&
				this.cartForm &&
				!this.cartForm.hasAttribute('data-applied') &&
				this.cartForm.hasAttribute('data-promo-enabled')
			) {
				if (discount === this.promoData.discountCode && this.promoData.variantID) {
					this.addGiftToCart(this.promoData.variantID);
				}
			}
		},

		async removeDiscount(code) {
			let discountMap = '';
			const discounts = this.cart.discount_codes.filter(
				(item) => item.code !== code && item.applicable === true,
			);
			if (discounts.length !== 0) {
				discountMap = discounts.map((item) => item.code).join(',');
			}

			this.$el.classList.add('loading');

			try {
				const url = `${window.Shopify.routes.root}cart/update.js`;
				const discountData = {
					discount: discountMap,
					sections: 'cart-main,cart-drawer-sections',
					sections_url: window.location.pathname,
				};

				if (this.promoData && code === this.promoData.discountCode) {
					discountData.updates = { [this.promoData.variantID]: 0 };
				}
				const config = {
					method: 'POST',
					credentials: 'same-origin',
					headers: {
						'Access-Control-Allow-Origin': 'no-cors',
						'Content-Type': 'application/json',
					},
					body: JSON.stringify(discountData),
				};

				const response = await fetch(url, config);
				const data = await response.json();
				if (!response.ok) return;
				this.$el.classList.remove('loading');

				this.$dispatch('cart-update', { cartData: data });
			} catch (error) {
				console.error(error);
			}
		},

		handleDiscountMessage(type, discount) {
			if (type == 'success') {
				this.$refs.cartDiscountMessagePlaceholder.innerHTML = this.discountMessages.success.replace(
					'[CODE]',
					discount.toUpperCase(),
				);
				this.$refs.cartDiscountMessage.classList.add('success');
				this.$refs.cartDiscountMessage.classList.remove('error');
			} else {
				this.$refs.cartDiscountMessagePlaceholder.innerHTML = this.discountMessages.error.replace(
					'[CODE]',
					discount.toUpperCase(),
				);
				this.$refs.cartDiscountMessage.classList.add('error');
				this.$refs.cartDiscountMessage.classList.remove('success');
			}
			setTimeout(() => {
				this.$refs.cartDiscountMessagePlaceholder.innerHTML = '';
				this.$refs.cartDiscountMessage.classList.remove('success', 'error');
				this.calculateItemsMaxHeight();
			}, 5000);
		},

		hideMessage() {
			this.$refs.cartDiscountMessage.classList.remove('success', 'error');
			this.calculateItemsMaxHeight();
		},

		handleProgressChange(parent, HTML) {
			const parentProgress = parent.querySelector('[data-progress-percent]');
			const HTMLprogress = HTML.querySelector('[data-progress-percent]');
			const HTMLprogressValue = HTML.dataset.cartDrawerProgress;
			if (parentProgress && HTMLprogress) {
				parentProgress.innerHTML = HTMLprogress.innerHTML;
				setTimeout(() => {
					parentProgress.style.cssText = `--progress-percent: ${HTMLprogressValue}%`;
				});
			}
		},

		calculateItemsMaxHeight() {
			let maxHeight = 0;
			const cartItems = document.querySelector('[data-cart-items]');
			this.getItemsForHeightCalculation().forEach((item) => {
				const section = document.querySelector(item);
				const height = section.clientHeight;
				maxHeight += height;
			});
			cartItems.style.height = `${window.innerHeight - maxHeight - 80}px`;
		},

		async addGiftToCart(id) {
			const url = window.routes.cartAdd + '.js';
			const productData = {
				items: [
					{
						id: id,
						quantity: 1,
					},
				],
				sections: 'cart-main,cart-drawer-sections',
			};

			const request = {
				method: 'POST',
				credentials: 'same-origin',
				headers: {
					'Content-Type': 'application/json',
					'X-Requested-With': 'XMLHttpRequest',
				},
				body: JSON.stringify(productData),
			};

			try {
				const response = await fetch(url, request);
				const result = await response.json();

				if (response.ok) {
					this.$dispatch('cart-update', { cartData: result });
				}
			} catch (error) {
				console.log(error);
			}
		},

		getItemsForHeightCalculation() {
			return ['.cart-drawer__banner', '[data-cart-footer]', '[data-cart-drawer-progress]'];
		},

		getPromoData() {
			this.cartForm = document.querySelector('#cart-items-form');
			if (this.cartForm && !this.cartForm.hasAttribute('data-promo')) return;
			this.promoData = JSON.parse(window.atob(this.cartForm.dataset.promo));
		},

		async addAutomatedGifts() {
			let giftsToAdd = [];
			let giftsToRemove = [];
			const getUrl = window.routes.cart + '.js';
			const addUrl = window.routes.cartAdd + '.js';
			const updateUrl = `${window.Shopify.routes.root}cart/update.js`;

			const response = await fetch(getUrl);
			if (response.status !== 200) return;
			const cart = await response.json();
			if (
				!this.autoGiftsData ||
				cart.item_count === 0 ||
				document.querySelector('.cart-drawer__empty')
			)
				return;

			if (this.checkExcluded(cart)) {
				for (let index = 0; index < this.autoGiftsData.gifts.length; index++) {
					const itemInCart = cart.items.some(
						(item) => item.variant_id === Number(this.autoGiftsData.gifts[index].id),
					);
					if (itemInCart) {
						giftsToRemove.push(this.autoGiftsData.gifts[index].id);
					}
				}
			} else {
				for (let index = 0; index < this.autoGiftsData.gifts.length; index++) {
					const itemInCart = cart.items.some(
						(item) => item.variant_id === Number(this.autoGiftsData.gifts[index].id),
					);
					if (!itemInCart && cart.total_price >= Number(this.autoGiftsData.gifts[index].amount)) {
						giftsToAdd.push(this.autoGiftsData.gifts[index].id);
					}

					if (itemInCart && cart.total_price < Number(this.autoGiftsData.gifts[index].amount)) {
						giftsToRemove.push(this.autoGiftsData.gifts[index].id);
					}
				}
			}

			if (giftsToAdd.length > 0) {
				const itemsToAdd = giftsToAdd.map((gift) => ({ id: gift, quantity: 1 }));
				const productData = {
					items: itemsToAdd,
					sections: 'cart-main,cart-drawer-sections',
				};

				const addRequest = {
					method: 'POST',
					credentials: 'same-origin',
					headers: {
						'Content-Type': 'application/json',
						'X-Requested-With': 'XMLHttpRequest',
					},
					body: JSON.stringify(productData),
				};
				try {
					const addResponse = await fetch(addUrl, addRequest);
					const addResult = await addResponse.json();

					if (addResponse.ok) {
						this.$dispatch('cart-update', { cartData: addResult });
					}
				} catch (error) {
					console.log(error);
				}
			}

			if (giftsToRemove.length > 0) {
				let updatesData = {
					updates: {},
					sections: 'cart-main,cart-drawer-sections',
				};

				giftsToRemove.forEach((item) => (updatesData.updates[item] = 0));

				const updateRequest = {
					method: 'POST',
					credentials: 'same-origin',
					headers: {
						'Content-Type': 'application/json',
						'X-Requested-With': 'XMLHttpRequest',
					},
					body: JSON.stringify(updatesData),
				};

				try {
					const updateResponse = await fetch(updateUrl, updateRequest);
					const updateResult = await updateResponse.json();

					if (updateResponse.ok) {
						this.$dispatch('cart-update', { cartData: updateResult });
					}
				} catch (error) {
					console.log(error);
				}
			}
		},

		checkExcluded(cart) {
			let disabled = false;

			if (this.autoGiftsData.excluded_variants === 0 || cart.items.length === 0) disabled = false;

			const notRelevantItem = cart.items.some(
				(item) =>
					!this.autoGiftsData.excluded_variants.includes(String(item.variant_id)) &&
					!this.autoGiftsData.gifts.some((gift) => Number(gift.id) === item.variant_id),
			);
			disabled = !notRelevantItem;

			return disabled;
		},

		init() {
			this.openCart();
			this.addAutomatedGifts();

			setTimeout(() => {
				this.calculateItemsMaxHeight();
			}, 500);
		},
	};
}
